// Controls
import { DynamicIcon } from "../dynamicIcon/DynamicIcon";
// Models
import { ContainerType } from "@ms/uno-models/lib/local/service/graph-legacy/container/ContainerType";
// Utilities
import React, { useMemo } from "react";
// Styles
import { boardSplitRegularIconProps, boardSplitFilledIconProps } from "../../../icons/icons.styles";
import { PlanDynamicIconStyles } from "./PlanIcon.styles";
/**
 * Control for showing correct icon or photo for a plan.
 */ export const LegacyPlanIcon = (props)=>{
    const { containerType, containerPhoto, focused = false, showIconOnly, name, size = 20, iconSvgSize = 16 } = props;
    const stateBasedIconToRender = useMemo(()=>{
        if (!showIconOnly && containerType === ContainerType.Group) {
            return containerPhoto;
        }
        return {
            normalIcon: boardSplitRegularIconProps,
            focusedIcon: boardSplitFilledIconProps
        };
    }, [
        containerType,
        containerPhoto,
        showIconOnly
    ]);
    return /*#__PURE__*/ React.createElement(DynamicIcon, {
        name: name,
        focused: focused,
        stateBasedIcons: stateBasedIconToRender,
        size: size,
        iconSvgSize: iconSvgSize,
        styles: PlanDynamicIconStyles
    });
};
